<template>
  <!-- Page Content -->
  <div class="row f-row justify-content-center h-100">
    <div class="f-row h-100">
      <div
        class="left-sidebar-front-div"
        v-if="userSelections.visibleLeft"
        @click="changeVisible"
      ></div>
      <!-- Sidebar lateral -->
      <LeftSidebar
        :selectedAnalysis="userSelections['selectedAnalysis']"
        :selectedAnalysisParent="userSelections['selectedAnalysisParent']"
        :visibleLeft="userSelections.visibleLeft"
        :selectedSheet="newSelectedSheet"
        @eventOnLeftSidebarAnalysis="onLeftSidebarAnalysis"
        @eventOnUserClickLeftSidebarShow="onUserClickLeftSidebarShow"
        @eventOnClientSelect="onClientSelectSheet"
      />
      <div class="h-100 d-flex flex-column largeBox row f-row">
        <div class="row f-row justify-content-center h-100 col-12">
          <div
            class="col col-12 text-center progress-div"
            v-if="showCompanyPortfolioLoading"
            style="top: 45%;"
          >
            <QSLoading
              :isLoading="showCompanyPortfolioLoading"
              :size="45"
              :colorTheme="colorTheme"
            />
          </div>
          <div :class="getStyleContainer()" v-else>
            <!-- No Companies created, new user -->
            <div class="row f-row mt-2 home-new-user" v-if="companyLen === 0">
              <div class="col col-12 text-center mt-2">
                Please name Your Company, one portfolio and select at least one
                currency (you will be able to create other portfolios
                afterwards).
              </div>
              <!--TODO: meter commodities-->
              <CreateCompanyComponent
                @eventOnAfterSaveCompany="onAfterSaveCompany"
                @eventOnBeforeSaveCompany="onBeforeSaveCompany"
              />
            </div>
            <!-- Company/Portfolio/Asset Selection -->
            <div class="row f-row mt-2 justify-content-start" v-else>
              <div
                class="txt-label-primary-2"
                style="width: 180px; justify-content: flex-start!important;"
                v-show="selectedSheet !== 3"
              >
                <span style="padding-left: 10px!important;"
                  >Create / Update:</span
                >&nbsp;
                <button
                  v-on:click="editCompanyPortfolios"
                  type="submit"
                  class="btn btn-up-dn-load"
                >
                  <i class="fa fa-edit" aria-hidden="true"></i>
                </button>
              </div>
              <div
                class="txt-label-primary-2"
                style="width: 80px; justify-content: flex-start!important;"
              >
                Company:
              </div>
              <div class="col col-2 ml-2 mr-4">
                <Dropdown
                  v-model="selectedCompany"
                  :options="companies"
                  @change="onUserCompanySelection"
                  optionLabel="company_name"
                  optionValue="id"
                  placeholder="Select a Company"
                  scrollHeight="400px"
                  :filter="true"
                >
                  <template #value="slotProps">
                    {{ companies[slotProps.value].company_name }}
                  </template>
                  <template #option="slotProps">
                    <div class="country-item">
                      <div>{{ slotProps.option.company_name }}</div>
                    </div>
                  </template>
                </Dropdown>
              </div>
              <div
                class="txt-label-primary-2"
                style="width: 80px; justify-content: flex-start!important;"
                v-show="selectedSheet !== 2 && selectedSheet !== 3"
              >
                Portfolios:
              </div>
              <div
                class="col col-2 ml-2 mr-4"
                v-show="selectedSheet !== 2 && selectedSheet !== 3"
              >
                <MultiSelect
                  v-model="selectedPortfolios"
                  :options="portfolios"
                  placeholder="Select Portfolios"
                  class="p-column-filter"
                  optionLabel="name"
                  scrollHeight="400px"
                  :filter="true"
                  @hide="onUserPortfolioSelection"
                >
                  <template #option="slotProps">
                    <div class="p-multiselect-representative-option">
                      <span class="image-text">{{
                        slotProps.option.name
                      }}</span>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div
                class="txt-label-primary-2"
                style="width: 80px; justify-content: flex-start!important;"
                v-if="selectedSheet !== 2 && selectedSheet !== 3"
              >
                Currencies:
              </div>
              <div
                class="col col-2 ml-2 mr-4"
                v-if="selectedSheet !== 2 && selectedSheet !== 3"
              >
                <MultiSelect
                  v-model="selectedCurrency"
                  :options="currencies"
                  placeholder="Select Portfolios"
                  class="p-column-filter"
                  optionLabel="name"
                  scrollHeight="400px"
                  :filter="true"
                  @hide="onUserCurrencySelection"
                >
                  <template #option="slotProps">
                    <div class="p-multiselect-representative-option">
                      <span class="image-text">{{
                        slotProps.option.name
                      }}</span>
                    </div>
                  </template>
                </MultiSelect>
              </div>
            </div>
          </div>
          <!-- Tab 0 selected / Currency Expo -->
          <div style="width: 100%;" v-if="selectedSheet === 0">
            <DataTableExpo
              :dataSaved="dataSavedExpo"
              :dataVar="expo"
              :headersToExport="
                headersExpo1.concat(headersExpo2).concat(headersExpo3)
              "
              :list_file="list_file"
              :processData="processData"
              :refreshLegend="refreshLegendExpo"
              :saveLegend="saveLegendExpo"
              :selectedCompany="selectedCompany"
              :selectedList="selectedSheet"
              :selectedNAsset="selectedNavAsset"
              :selectedPortfolios="selectedPortfolios"
              :showLoading="showLoadingExpo"
              @eventOnClientCreate="onClientCreateExpo"
              @eventOnEditItem="editItemExpo"
              @eventOnDeleteItem="deleteItemExpo"
              @eventOnCopyItem="onCopyItem"
              @eventOnClientSaveToDB="onClientSaveToDB(1)"
              @eventOnClientDiscard="onClientDiscardExpo"
              @eventOnAfterDelete="onAfterDeleteExpo"
              @eventOnAfterDeleteCompany="onAfterDeleteCompany"
            />
          </div>
          <!-- Tab 1 selected / Hedge -->
          <div style="width: 100%;" v-else-if="selectedSheet === 1">
            <DataTableHedge
              :dataSaved="dataSavedHedge"
              :dataVar="hedge"
              :headersToExport="
                headersHedge1.concat(headersHedge2).concat(headersHedge3)
              "
              :list_file="list_file"
              :optionTypes="optionTypes"
              :processData="processData"
              :refreshLegend="refreshLegendHedge"
              :saveLegend="saveLegendHedge"
              :selectedCompany="selectedCompany"
              :selectedList="selectedSheet"
              :selectedNAsset="selectedNavAsset"
              :selectedPortfolios="selectedPortfolios"
              :showLoading="showLoadingHedge"
              @eventOnClientCreate="onClientCreateHedge"
              @eventOnEditItem="editItemHedge"
              @eventOnCopyItem="onCopyItemHedge"
              @eventOnDeleteItem="deleteItemHedge"
              @eventOnClientSaveToDB="onClientSaveToDB(2)"
              @eventOnClientDiscard="onClientDiscardHedge"
              @eventOnAfterDelete="onAfterDeleteHedge"
              @eventOnAfterDeleteCompany="onAfterDeleteCompany"
            />
          </div>
          <!-- Tab 2 selected / Program -->
          <div
            class="row f-row h-100"
            style="width: 100%;"
            v-else-if="selectedSheet === 2"
          >
            <div class="col col-12 h-100">
              <DataModelProgram
                :colorTheme="colorTheme"
                :portfolioList="portfolios"
                :processData="processData"
                :programType="'currencies'"
                :selectedAsset="selectedNavAsset"
                :selectedCompany="companies[selectedCompany]"
                :selectedPortfolios="selectedPortfolios"
                :watcherCompanySelected="watcherCompanySelected"
                @eventOnProgramSelectionChange="onDataProgramSelection"
              />
            </div>
          </div>
          <!-- Tab 4 upload file -->
          <div
            class="row f-row parent-uploadFile"
            v-else-if="selectedSheet === 3"
          >
            <UploadFile
              :colorTheme="colorTheme"
              :companyInformation="companyInformation"
            />
          </div>
          <!-- New/Edit Expo Modal -->
          <div class="modal-upload-expo" v-if="showModalEditExpo">
            <NewEditExpoCurrencies
              :allCurrencies="allCurrencies"
              :colorTheme="colorTheme"
              :createEditTextExpo="createEditTextExpo"
              :editedItemExpo="editedItemExpo"
              :expoOptions="expoOptions"
              @eventOnUserCancel="onUserCancel"
              @eventOnValidateBeforeSubmit="validateBeforeSubmit"
            />
          </div>
          <!-- New/edit Hedge Modal -->
          <div class="modal-upload-expo" v-if="showModalEditHedge">
            <NewEditHedgeCurrencies
              :allCurrencies="allCurrencies"
              :colorTheme="colorTheme"
              :createEditTextHedge="createEditTextHedge"
              :editedItemHedge="editedItemHedge"
              :optionTypes="optionTypes"
              :strategies="strategies"
              @eventOnUserCancel="onUserCancel"
              @eventOnValidateBeforeSubmit="validateBeforeSubmitHedge"
            />
          </div>
          <!-- Loading Modal -->
          <Messages
            :modal_message="modal_processing_message"
            :colorTheme="colorTheme"
          />
          <Messages
            :modal_message="modal_process_finished_message"
            :colorTheme="colorTheme"
          />
          <div v-if="companyLen > 0">
            <CompanyPortfoliosEdit
              :modal_message="modal_edit_company"
              :companies="companies"
              :selectedCompany="selectedCompany"
              :user="user"
              :watcherForEditCompany="watcherForEditCompany"
              :colorTheme="colorTheme"
              @eventOnAfterSavePortfolioCompany="onAfterSavePortfolioCompany"
              @eventOnBeforeSavePortfolioCompany="onBeforeSavePortfolioCompany"
            />
          </div>
          <!-- Loading Modal -->
          <div class="modal-upload-expo" v-show="showModalLoading">
            <div class="inside-modal">
              <div class="row f-row text-center">
                <div class="col col-12 progress-div" style="top: 30%;">
                  <img
                    :src="logo"
                    @mouseover="logo = logo_blue"
                    @mouseout="logo = logo_white"
                    height="40"
                    alt=""
                    style="padding: 0"
                  /><br /><br />
                  <span>Loading Your information... please wait</span
                  ><br /><br /><br />
                  <QSLoading
                    :isLoading="showModalLoading"
                    :size="45"
                    :colorTheme="colorTheme"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyPortfoliosEdit from "@/components/modals/CompanyPortfoliosEdit";
import CreateCompanyComponent from "@/components/CreateCompanyPortfolio.vue";
import DataModelProgram from "@/components/dataModel/DataModelProgram";
import DataTableExpo from "@/components/dataModel/DataTableExpo.vue";
import DataTableHedge from "@/components/dataModel/DataTableHedge";
import Dropdown from "primevue/dropdown";
import Messages from "@/components/modals/Messages.vue";
import MultiSelect from "primevue/multiselect";
import NewEditExpoCurrencies from "@/components/dataModel/NewEditExpoCurrencies";
import NewEditHedgeCurrencies from "@/components/dataModel/NewEditHedgeCurrencies";
import { getExpoData } from "@/_core/data/api_calls/getExpoData";
import { getExpoOptionsData } from "@/_core/data/api_calls/getExpoOptionsData";
import { getHedgeData } from "@/_core/data/api_calls/getHedgeData";
import { getOptionTypesData } from "@/_core/data/api_calls/getOptionTypesData";
import { getStrategiesData } from "@/_core/data/api_calls/getStrategiesData";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import {
  companyPortfolioAsset,
  getDefaultItemExpo,
  getDefaultItemHedge,
  getFirstCompany,
  getHeadersExpo1,
  getHeadersExpo2,
  getHeadersExpo3,
  getHeadersHedge1,
  getHeadersHedge2,
  getHeadersHedge3,
  setManagementInfo,
} from "@/_core/data/DataModel";
import {
  onClientSaveToDBExpo,
  onClientSaveToDBHedge,
} from "@/_core/data/SaveToDB";
import { timeParseNoNull } from "@/_core/_helpers/_helpers";
import LeftSidebar from "./sidebar/LeftSidebar.vue";
import UploadFile from "./uploadFile/UploadFile.vue";
import QSLoading from "@/components/QSLoading.vue";
import { dataModelRouteSync } from "./dataModelRouteSync";

export default {
  name: "Currency",
  mixins: [dataModelRouteSync],
  components: {
    QSLoading,
    CompanyPortfoliosEdit,
    CreateCompanyComponent,
    DataTableExpo,
    DataTableHedge,
    Dropdown,
    Messages,
    MultiSelect,
    DataModelProgram,
    LeftSidebar,
    NewEditExpoCurrencies,
    NewEditHedgeCurrencies,
    UploadFile,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    companies: { required: true, default: [{ id: 0, company_name: "N.A." }] },
    currencySpecs: { required: true, default: () => [] },
    processData: { required: true },
    selectedNavAsset: { required: true, default: 0 },
    selectedSheet: { required: true, default: 0 },
    user: { required: true },
  },
  data() {
    return {
      allCurrencies: [],
      currencies: [],
      companyInformation: null,
      companyLen: 1,
      createEditTextExpo: "Add New Exposure",
      createEditTextHedge: "Add New Hedge",
      datamodel_preferences: {},
      dataSavedExpo: true,
      dataSavedHedge: true,
      dataToExport: [],
      defaultItemExpo: {},
      defaultItemHedge: {},
      editedIndexExpo: -1,
      editedIndexHedge: -1,
      editedItemExpo: { fk_idcurrency: "EURUSD", fk_idcountry_currency: "USD" },
      editedItemHedge: {},
      expo_deleted: [],
      expo: [],
      expoOptions: [],
      file: "",
      firstCompany: [],
      headersExpo1: [],
      headersExpo2: [],
      headersExpo3: [],
      headersHedge1: [],
      headersHedge2: [],
      headersHedge3: [],
      headersToExport: [],
      hedge_deleted: [],
      hedge: [],
      leftRightCurrExpo: "",
      leftRightCurrHedge: "",
      list_file: "",
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      modal: false,
      modal_edit_company: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      newSelectedSheet: null,
      optionTypes: [],
      portfolios: [],
      prevSelectedCurrency: [],
      prevSelectedPortfolios: [],
      refreshLegendExpo: "Synced:",
      refreshLegendHedge: "Synced:",
      root: document.documentElement,
      saveLegendExpo: "Saved:",
      saveLegendHedge: "Saved",
      selectedCompany: 0,
      selectedCurrency: [],
      selectedPortfolios: [],
      sheetTransaction: null,
      showCompanyPortfolioLoading: false,
      showLoadingCompanies: false,
      showLoadingExpo: false,
      showLoadingHedge: false,
      showLoadingStrategies: false,
      showModalEditExpo: false,
      showModalEditHedge: false,
      showModalLoading: false,
      showModalUpload: false,
      showUploadButton: false,
      strategies: [],
      userSelections: {
        selectedAnalysis: "",
        selectedAnalysisParent: "",
        visibleLeft: false,
      },
      watcherCompanySelected: 0,
      watcherForEditCompany: 0,
    };
  },
  created() {
    this.headersExpo1 = getHeadersExpo1();
    this.headersExpo2 = getHeadersExpo2();
    this.headersExpo3 = getHeadersExpo3();
    this.headersHedge1 = getHeadersHedge1();
    this.headersHedge2 = getHeadersHedge2();
    this.headersHedge3 = getHeadersHedge3();
    this.firstCompany = getFirstCompany();
    this.defaultItemExpo = getDefaultItemExpo();
    this.editedItemExpo = getDefaultItemExpo();
    this.defaultItemHedge = getDefaultItemHedge();
    this.editedItemHedge = getDefaultItemHedge();
    this.showLoadingStrategies = true;
    getStrategiesData(this, "strategies", "showLoadingStrategies");
    this.datamodel_preferences = this.$store.state.user_preferences.all.items.datamodel_choices;
    try {
      let selComp = this.$store.state.user_preferences.all.items
        .datamodel_choices.selected_company;
      if (
        !Number.isInteger(selComp) ||
        this.companies.find((d) => d.id === selComp) === undefined
      ) {
        this.selectedCompany = 0;
      } else {
        this.selectedCompany = selComp;
      }
    } catch (error) {
      console.log(`Error selected company ${error}`);
      this.selectedCompany = 0;
    }
    try {
      this.allCurrencies = this.$store.state.currencies.all.items;
    } catch (error) {
      console.log(`Error currencies ${error}`);
    }

    setManagementInfo(this, 0, true, !this.dataRouteHasSelection(this.$route));
    getExpoOptionsData(this);
    getOptionTypesData(this);
    this.changeCompanyInformation();
    this.newSelectedSheet = this.selectedSheet;
    Object.assign(this.userSelections, {
      selectedAnalysis: `eventOnClientSelect${this.selectedSheet}`,
      selectedAnalysisParent: `eventOnClientSelect${this.selectedSheet}`,
    });

    // Apply the company/portfolios/currencies selection carried in the URL
    // (or write the current defaults out so the URL becomes shareable).
    this.applyDataRoute(this.$route);

    document.title = "Data Model | Fx";
  },
  watch: {
    companies() {
      this.showModalLoadingF();
      "loading" in this.companies
        ? (this.companyLen = 1)
        : (this.companyLen = this.companies.length);
    },
    selectedCompany() {
      this.changeCompanyInformation();
    },
  },
  methods: {
    // ====================== Client Company/Portfolio/Asset Selection ======================
    onClientSelectSheet({ idx }) {
      this.$emit("eventOnClientSelectSheet", idx);
    },
    onUserCompanySelection(event) {
      this.selectedCompany = event.value;
      this.datamodel_preferences.selected_company = this.selectedCompany;
      this.$store.state.user_preferences.all.items.datamodel_choices = this.datamodel_preferences;
      companyPortfolioAsset(this, 0);
      this.setFileNameData();
      saveUserPreferences(this);
      this.changeCompanyInformation();
      this.syncDataRoute();
    },
    onUserPortfolioSelection() {
      if (this.selectedPortfolios !== this.prevSelectedPortfolios) {
        this.prevSelectedPortfolios = this.selectedPortfolios;
        companyPortfolioAsset(this, 1);
      }
      this.syncDataRoute();
    },
    onUserCurrencySelection() {
      if (this.selectedCurrency !== this.prevSelectedCurrency) {
        this.prevSelectedCurrency = this.selectedCurrency;
        companyPortfolioAsset(this, 2);
      }
      this.syncDataRoute();
    },
    onCopyItem(item) {
      this.editedIndexExpo = this.expo.indexOf(item);
      item = Object.assign({}, item);
      item.edited = true;
      item.pk = "pending";
      item.pk_idcurrencyexposure = NaN;
      this.expo.splice(this.editedIndexExpo, 0, item);
      this.dataSavedExpo = false;
      this.saveLegendExpo = "Save:";
      this.refreshLegendExpo = "Discard:";
    },
    // ====================== CRUD emit from expo table component =======
    onClientSaveToDB(val) {
      if (val === 1) {
        Object.assign(this.modal_processing_message, {
          showModalLoading: true,
          messageModal: "Processing...",
          optionsModal: false,
        });
        onClientSaveToDBExpo(this);
      } else if (val === 2) {
        onClientSaveToDBHedge(this);
      }
    },
    onBeforeSaveCompany() {
      this.showCompanyPortfolioLoading = true;
    },
    onAfterSaveCompany() {
      this.showCompanyPortfolioLoading = true;
      this.companies = this.$store.state.companies.all.items;
      this.companyLen = this.companies.length;
      const delay_state = this;
      setTimeout(() => (delay_state.showCompanyPortfolioLoading = false), 2000);
      setManagementInfo(this);
    },
    onBeforeSavePortfolioCompany() {
      Object.assign(this.modal_processing_message, {
        showModalLoading: !this.modal_processing_message.showModalLoading,
        messageModal: "Processing...",
        optionsModal: false,
      });
      this.showCompanyPortfolioLoading = true;
    },
    onAfterSavePortfolioCompany(item) {
      Object.assign(this.modal_processing_message, {
        showModalLoading: !this.modal_processing_message.showModalLoading,
        optionsModal: true,
      });
      Object.assign(this.modal_process_finished_message, {
        showModalLoading: !this.modal_process_finished_message.showModalLoading,
        messageModal: item,
        optionsModal: true,
      });

      this.companies = this.$store.state.companies.all.items;
      this.companyLen = this.companies.length;
      setManagementInfo(this);
      this.showCompanyPortfolioLoading = false;
    },
    editCompanyPortfolios() {
      this.watcherForEditCompany += 1;
      this.modal_edit_company.showModalLoading = !this.modal_edit_company
        .showModalLoading;
      this.modal_edit_company.messageModal = "Edit company and portfolios";
      this.modal_edit_company.optionsModal = true;
    },
    // ====================== CRUD emit from expo table component =======
    onClientCreateExpo() {
      this.editedItemExpo = JSON.parse(JSON.stringify(this.defaultItemExpo));
      this.editedItemExpo.fk_idportafolio = this.selectedPortfolios[0].name;
      this.editedItemExpo.fk_idcurrency = this.selectedCurrency[0].name;
      this.createEditTextExpo = "Add New Exposure";
      this.showModalEditExpo = true;
      this.editedIndexExpo = -1;
    },
    onAfterDeleteHedge() {
      this.showLoadingHedge = true;
      getHedgeData(this);
      this.showLoadingCompanies = !this.showLoadingCompanies;
    },
    onAfterDeleteExpo() {
      this.showLoadingExpo = true;
      getExpoData(this);
      this.showLoadingCompanies = !this.showLoadingCompanies;
    },
    onAfterDeleteCompany() {
      this.showLoadingExpo = true;
      this.companyLen = this.companies.length;
      this.showLoadingCompanies = !this.showLoadingCompanies;
    },
    showModalLoadingF() {
      let res = true;
      if (this.companies) {
        res = "loading" in this.companies;
      }
      this.showModalLoading = res;
    },
    editItemExpo(item) {
      this.editedIndexExpo = this.expo.indexOf(item);
      if (item.rate_at_realized_expiration_date === undefined) {
        item.rate_at_realized_expiration_date === "";
      }
      this.editedItemExpo = JSON.parse(JSON.stringify(item));
      this.createEditTextExpo = "Edit Exposure";
      this.showModalEditExpo = true;
    },
    deleteItemExpo(item) {
      const index = this.expo.indexOf(item);
      const r = confirm("Are you sure you want to delete this item?");
      if (r === true) {
        item.fk_idstate = 2;
        this.expo_deleted.push(item);
        this.expo.splice(index, 1);
        this.dataSavedExpo = false;
        this.saveLegendExpo = "Save:";
        this.refreshLegendExpo = "Discard:";
      }
    },
    onClientDiscardExpo() {
      this.showLoadingExpo = true;
      getExpoData(this);
    },
    onUserCancel() {
      this.showModalEditExpo = false;
      this.showModalEditHedge = false;
    },
    validateBeforeSubmit(val) {
      this.editedItemExpo = val;
      this.saveExpo();
      this.showModalEditExpo = false;
    },
    saveExpo() {
      let item;
      if (this.editedIndexExpo > -1) {
        item = this.fixExpoJson(
          JSON.parse(JSON.stringify(this.editedItemExpo)),
        );
        Object.assign(this.expo[this.editedIndexExpo], item);
      } else {
        this.editedItemExpo.pk = "pending";
        item = this.fixExpoJson(
          JSON.parse(JSON.stringify(this.editedItemExpo)),
        );
        this.expo.splice(0, 0, item);
      }
      this.defaultItemExpo = this.fixExpoJson(
        JSON.parse(JSON.stringify(this.editedItemExpo)),
      );
      this.dataSavedExpo = false;
      this.saveLegendExpo = "Save:";
      this.refreshLegendExpo = "Discard:";
    },
    fixExpoJson(item) {
      if (item.rate_at_issue_date === "") {
        item.rate_at_issue_date = null;
      }
      if (item.rate_at_realized_expiration_date === "") {
        item.rate_at_realized_expiration_date = null;
      }
      if (item.settlement_pnl === "") {
        item.settlement_pnl = null;
      }
      item.issue_date = timeParseNoNull(item.issue_date);
      item.expiration_date = timeParseNoNull(item.expiration_date);
      item.planned_expiration_date = timeParseNoNull(
        item.planned_expiration_date,
      );
      item.realized_expiration_date = timeParseNoNull(
        item.realized_expiration_date,
      );
      item.hedged_date = timeParseNoNull(item.hedged_date);
      item.sale_date = timeParseNoNull(item.sale_date);
      item.shipping_date = timeParseNoNull(item.shipping_date);
      return item;
    },
    onCopyItemHedge(item) {
      this.editedIndexHedge = this.hedge.indexOf(item);
      item = Object.assign({}, item);
      item.edited = true;
      item.pk = "pending";
      item.pk_idcurrencyhedge = NaN;
      this.hedge.splice(this.editedIndexHedge, 0, item);
      this.dataSavedHedge = false;
      this.saveLegendHedge = "Save:";
      this.refreshLegendHedge = "Discard:";
    },
    // ====================== CRUD emit from hedge table component =======
    onClientCreateHedge() {
      this.editedItemHedge = JSON.parse(JSON.stringify(this.defaultItemHedge));
      this.editedItemHedge.fk_idportafolio = this.selectedPortfolios[0].name;
      this.editedItemHedge.fk_idcurrency = this.selectedCurrency[0].name;
      this.createEditTextHedge = "Add New Hedge";
      this.showModalEditHedge = true;
      this.editedIndexHedge = -1;
    },
    editItemHedge(item) {
      this.editedIndexHedge = this.hedge.indexOf(item);
      this.editedItemHedge = JSON.parse(JSON.stringify(item));
      this.createEditTextHedge = "Edit Hedge";
      this.showModalEditHedge = true;
    },
    deleteItemHedge(item) {
      const index = this.hedge.indexOf(item);
      const r = confirm("Are you sure you want to delete this item?");
      if (r === true) {
        item.fk_idstate = 2;
        this.hedge_deleted.push(item);
        this.hedge.splice(index, 1);
        this.dataSavedHedge = false;
        this.saveLegendHedge = "Save:";
        this.refreshLegendHedge = "Discard:";
      }
    },
    onClientDiscardHedge() {
      this.showLoadingHedge = true;
      getHedgeData(this);
    },
    validateBeforeSubmitHedge(val) {
      this.editedItemHedge = val;
      this.saveHedge();
      this.showModalEditHedge = false;
    },
    saveHedge() {
      if (this.editedIndexHedge > -1) {
        Object.assign(
          this.hedge[this.editedIndexHedge],
          this.fixHedgeJson(JSON.parse(JSON.stringify(this.editedItemHedge))),
        );
      } else {
        this.hedge.splice(
          0,
          0,
          this.fixHedgeJson(JSON.parse(JSON.stringify(this.editedItemHedge))),
        );
        this.defaultItemHedge = this.fixHedgeJson(
          JSON.parse(JSON.stringify(this.editedItemHedge)),
        );
      }
      this.dataSavedHedge = false;
      this.saveLegendHedge = "Save:";
      this.refreshLegendHedge = "Discard:";
    },
    fixHedgeJson(item) {
      if (item.barrier === "") {
        item.barrier = null;
      }
      if (item.barrier_2 === "") {
        item.barrier_2 = null;
      }
      if (item.spot_reference === "") {
        item.spot_reference = null;
      }
      if (item.settlement_rate === "") {
        item.settlement_rate = null;
      }
      if (item.settlement_pnl === "") {
        item.settlement_pnl = null;
      }
      item.trade_date = timeParseNoNull(item.trade_date);
      item.fixing_date = timeParseNoNull(item.fixing_date);
      item.value_date = timeParseNoNull(item.value_date);
      item.premium_value_date = timeParseNoNull(item.premium_value_date);
      item.asian_fixing_start_date = timeParseNoNull(
        item.asian_fixing_start_date,
      );
      item.hedged_date = timeParseNoNull(item.hedged_date);
      item.sale_date = timeParseNoNull(item.sale_date);
      item.shipping_date = timeParseNoNull(item.shipping_date);
      return item;
    },
    // ====================== Variables calculation ======================
    setFileNameData() {
      this.list_file = [this.companies[this.selectedCompany].company_name];
    },
    //  ====================== User interactions  ======================
    changeVisible() {
      Object.assign(this.userSelections, {
        visibleLeft: !this.userSelections.visibleLeft,
      });
    },
    onLeftSidebarAnalysis({ val, parent }) {
      Object.assign(this["userSelections"], {
        selectedAnalysisParent: parent,
      });
      Object.assign(this["userSelections"], {
        selectedAnalysis: val,
      });
      setTimeout(() => {
        Object.assign(this["userSelections"], {
          visibleLeft: false,
        });
      }, 500);
    },
    onUserClickLeftSidebarShow(val) {
      Object.assign(this["userSelections"], {
        visibleLeft: val,
      });
    },
    changeCompanyInformation() {
      const companySel = this.companies[this.selectedCompany];
      Object.assign(this, {
        companyInformation: {
          idCompany: companySel.pk_idcompany,
          companyName: companySel.company_name,
        },
      });
    },
    //  ====================== Set styles  ======================
    getStyleContainer() {
      if (this.selectedSheet === 3) {
        return "container-curr-actions-l";
      } else {
        return "container-curr-actions-xl";
      }
    },
  },
};
</script>

<style scoped>
.parent-uploadFile {
  width: 95%;
  height: 90%;
}
.container-curr-actions-l {
  width: 95%;
}
.container-curr-actions-xl {
  width: 100%;
}
</style>
